module.exports = __webpack_public_path__ + "img/tiki.78e644d6.png";